import * as React from "react";

import "./office-search-field.scss";

import {cs}           from "@Common/react/chain-services";
import {officeSearch} from "@Common/ui-components/searchable-select/office-search";

import {getInfoTip} from "../common/get-info-tip";

export const OfficeSearchField = ({textField, cc}) => {
    let defaultValue = ''
    try {
        let value = JSON.parse( textField.value );
        defaultValue = value.idBranch
    } catch (e) {
        defaultValue = ''
    }
    return (
        <div className="relative edit-form-search-3c6">
            {officeSearch(textField, defaultValue)}
            {getInfoTip(textField, cc.sourceData)}
        </div>
    )
};

